export function resetMapView(mapClass) {
    if(!mapClass) return;
    let bounds = [];
    Object.values(mapClass._layers).map((layer) => {
        if (layer._latlng) {
            bounds.push(layer._latlng);
        }
    });

    if(bounds.length > 0) {
        mapClass.fitBounds(bounds, { padding: [20, 20] });
    }
}